<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :showFooter="false"
    :showCancelBtn="false"
    class="history-reward-info"
    width="50%"
    append-to-body
    :visible.sync="visible"
    :showIcon="false"
  >
    <template slot="title">
      {{ title }}
    </template>

    <el-container direction="vertical" class="info--container">
      <!-- 分類 -->
      <el-row type="flex" justify="start" class="info-row" :style="{'display':showCategory}">
          <el-col :span="6" class="info-row--column">
              <span>
              {{ $t("component.label.categories") }}
              </span>
          </el-col>
          <el-col :span="18" class="info-row--action" >
            <el-select style="width:100%;height:100%;text-align:center;" v-model="selected_category" @change="handleClickCategory()">
              <el-option value="" :label="$t('enum.date_filter[0]')"></el-option>
              <el-option v-for="(item,i) in categories" :value="i" :key="item" :label="$t('enum.category.' + item)"></el-option>
            </el-select>
          </el-col>
      </el-row>

      <!-- 平台 -->
      <el-row type="flex" justify="start" class="info-row" :style="{'display':showPlatform}">
          <el-col :span="6" class="info-row--column">
              <span>
              {{ $t("component.label.source_type") }}
              </span>
          </el-col>
          <el-col :span="18" class="info-row--action">
            <el-select :disabled="(selected_category !== '' && categories[selected_category] === 'tg') || selected_category === ''" style="width:100%;height:100%;text-align:center;" v-model="selected_source_type" @change="handleClickSourceType()">
              <el-option value="" :label="$t('enum.date_filter[0]')"></el-option>
              <el-option v-for="item in source_type" :value="item" :key="item" :label="$t('component.label.source_type.' + item)"></el-option>
            </el-select>
          </el-col>
      </el-row>

      <!-- 玩法 -->
      <el-row type="flex" justify="start" class="info-row">
          <el-col :span="6" class="info-row--column">
              <span>
              {{ $t("component.label.markets") }}
              </span>
          </el-col>
          <el-col :span="18" class="info-row--action">
            <el-select :disabled="selected_category === ''" style="width:100%;height:100%;text-align:center;" v-model="selected_market" >
              <el-option value="" :label="$t('enum.date_filter[0]')"></el-option>
              <template>
                <el-option v-for="item in markets" :value="item.value" :key="item.categoryName + item.value" :label="item.text"></el-option>
              </template>
            </el-select>
          </el-col>
      </el-row>
      
    </el-container>
    <tg-button
        round
        :classes="['tg-btn--confirm']"
        @click.native="handleClick()"
        >
        {{ $t("component.btn.confirm") }}
    </tg-button>
  </tg-dialog>
</template>

<script>
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog.vue";

import apis from "@/apis";

const api = apis.accounts.history;

const _CATEGORIES = ['tg','sports','casino','chess','slots','lottery','e-sports'];

export default {
  inheritAttrs: false,
  components: {
    TgButton,
    TgDialog,
  },

  data() {
    return {
        defaultOptions: {name: 'all', value:'all'},
        selected: {name: 'all', value:'all'},
        visible: false,
        selected_category: "",
        selected_source_type: "",
        selected_market:"",
        third_party_data:[],
    };
  },
  props: {
    filters: Array,
    third_party: Array
  },
  computed: {
    title() {
      return this.$t('component.label.betContentFilter');
    },
    categories() {
      // let array = [];
      return this.third_party.map((r) => {
        return _CATEGORIES[r.category];
      }).filter((v, i, a) => a.indexOf(v) === i);
    },
    source_type() {
      let current_category = this.selected_category;
      return this.third_party.filter(x => {

        //全部
        if(this.selected_category === ''){
          return true;
        }else{
          return _CATEGORIES[x.category] == this.categories[current_category];
        }
        
      }).map(r => {
        return r.platform;
      });
    },
    markets() {
      let current_category = this.selected_category;

      let current_source_type = this.selected_source_type;

      return this.filters.filter(x => {
        if (current_category === '' && current_source_type === '') {
          return true;
        }

        if (current_category === 'tg') {
          return x.name === 'tg';
        }

        if(current_category === '' && x.name == this.selected_source_type){
          return true;
        }

        return _CATEGORIES[x.category] == this.categories[current_category] && (current_source_type === '' || x.name == current_source_type);
      }).reduce((a, c) => {
        let d = [];
        
        d = c.children.map(r => {
          r.categoryName = c.name;
          return r;
        });
        a.push.apply(a, d);
        return a;
      }, []);
    },
    showCategory() {
      return Object.keys(this.third_party_data).length <= 1 ? 'none':"initial";
    },
    showPlatform() {
      return Object.keys(this.third_party_data).length <= 1 ? 'none':"initial";
    },
  },
  created() {
    let array = [{'platform':'tg','category':0}];
    this.thirdParties.forEach(element => {
      array.push(element);
    });
    this.third_party_data = array;

    if(this.third_party_data.length <= 1){
      this.selected_category = 'tg';
      this.selected_source_type = 'tg';
    }
    // apis.getThirdPartys().then((response) => {
    //   if (response.retcode == 0) {
    //     this.third_party_data = response.data;
    //     let array = [{'platform':'tg','category':0}];
    //     response.data.forEach(element => {
    //       array.push(element);
    //     });
    //     this.third_party_data = array;
    //   }
    // });
  },
  methods: {
    showDialog() {
      this.visible = true;
    },
    handleClickCategory(){
      let current_category = this.selected_category;

      if(current_category !== ''){
        this.selected_source_type = this.third_party.find(x=>_CATEGORIES[x.category] === this.categories[current_category]).platform;
        this.getSelection();
      }else{
        this.selected_source_type = '';
        this.handleClickSourceType();
      }
    },
    handleClickSourceType(){
      if( this.selected_source_type !== ''){
        this.getSelection();
      }else{
        this.selected_market = '';
      }
    },
    handleClick() {
      this.visible = false;

      let selected_source_type = [];
      
      if(this.selected_market == ''){
        if(this.selected_source_type == ''){
          if(this.selected_category == ''){
            selected_source_type = this.third_party.map(r => {
              return r.platform;
            });
            this.$emit('on-handle', selected_source_type);
          }else{
            let current_category = this.selected_category;
            
            selected_source_type = this.third_party.filter(x => {
              return _CATEGORIES[x.category] == this.categories[current_category];
            }).map(r => {
              return r.platform;
            });
            this.$emit('on-handle', selected_source_type);
          }
        }else{
          this.$emit('on-handle', [this.selected_source_type]);
        }
      }else{
        this.$emit('on-change', this.selected_market);
      }
      
    },
    getSelection(){
      this.$nextTick(() => {
          this.filters.filter(x => {
            if(x.name == this.selected_source_type ){
              if(x.children.length == 0){
                api.getSelection({"third_party":this.selected_source_type}).then((response) => {
                  x.children = response.data[this.selected_source_type].filters;
                });
              }

              if(this.markets[0] && this.markets[0].value){
                this.selected_market = this.markets[0].value;
              }else{
                this.selected_market = "";
              }
              

              return true;
            }
          });
        });
    }
  },
};
</script>
